import { makeAutoObservable } from "mobx";
import { WenxinStatusType } from "@/types/value-added";
import { ObjKeysCamelFormat, ObjKeysSnakeFormat } from "@/utils/variableName";
import { loginStore } from "@/modules/login/store";
import { HeartCoinData, userAssetsStore } from "@/stores/userAssets";

const defaultWenxinStatus: WenxinStatusType = {
  freeBalance: 0,
  totalBalance: 0,
  payBalance: 0,
  lockedBalance: 0,
};
class WenxinStore {
  _data: WenxinStatusType = defaultWenxinStatus;
  showHighlight = false;

  get data() {
    const { free, froze, total, payed } = userAssetsStore.heartCoinInfo;
    return {
      freeBalance: free,
      totalBalance: total,
      payBalance: payed,
      lockedBalance: froze,
    };
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setData(data: WenxinStatusType) {
    userAssetsStore.setHeartCoinInfo(ObjKeysSnakeFormat(data) as HeartCoinData);
  }

  reset() {
    this.setData({ ...defaultWenxinStatus });
  }

  setShowHighlight = (show: boolean) => {
    this.showHighlight = show;
  };

  openHighlight = () => {
    if (!localStorage.getItem("wenxin_highlighted") && !loginStore.isGuest) {
      this.setShowHighlight(true);
    }
  };

  fetchWenxinStatus() {
    userAssetsStore.fetchHeartCoin().then((res) => {
      if (res) {
        this.setData(ObjKeysCamelFormat(res.data) as WenxinStatusType);
      }
    });
  }
}

export const wenxinStore = new WenxinStore();
export { WenxinStore };
